var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigRuleActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.006,
    height: 31.729,
    viewBox: "0 0 26.006 31.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2A7DE1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29 -356)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2106.374-2619.71H-2126.6a3.044,3.044,0,0,1-2.889-3.172v-22.21a3.044,3.044,0,0,1,2.889-3.173h6.04a4.407,4.407,0,0,1,4.074-3.173,4.407,4.407,0,0,1,4.074,3.173h6.039a3.045,3.045,0,0,1,2.89,3.173v22.21A3.044,3.044,0,0,1-2106.374-2619.71Zm-13.618-9.065a1,1,0,0,0-1,1v.833a1,1,0,0,0,1,1h10.748a1,1,0,0,0,1-1v-.833a1,1,0,0,0-1-1Zm-4.25,0a1,1,0,0,0-1,1v.833a1,1,0,0,0,1,1h.833a1,1,0,0,0,1-1v-.833a1,1,0,0,0-1-1Zm4.25-5.667a1,1,0,0,0-1,1v.833a1,1,0,0,0,1,1h10.748a1,1,0,0,0,1-1v-.833a1,1,0,0,0-1-1Zm-4.25,0a1,1,0,0,0-1,1v.833a1,1,0,0,0,1,1h.833a1,1,0,0,0,1-1v-.833a1,1,0,0,0-1-1Zm4.25-5.666a1,1,0,0,0-1,1v.833a1,1,0,0,0,1,1h10.748a1,1,0,0,0,1-1v-.833a1,1,0,0,0-1-1Zm-4.25,0a1,1,0,0,0-1,1v.833a1,1,0,0,0,1,1h.833a1,1,0,0,0,1-1v-.833a1,1,0,0,0-1-1Zm7.754-8.158a1.522,1.522,0,0,0-1.446,1.586,1.523,1.523,0,0,0,1.446,1.587,1.522,1.522,0,0,0,1.445-1.587A1.522,1.522,0,0,0-2116.487-2648.265Z",
    transform: "translate(2158.49 3007.438)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigRuleActive);
export default __webpack_public_path__ + "static/media/configRuleActive.e81b29072978c8e0d4a95f564c2066d9.svg";
export { ForwardRef as ReactComponent };